import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { Form} from 'react-bootstrap';
import useFormGenerator from '../../common/FormUtils';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../../common/FormModal';
import PersonalRecordService from './PersonalRecordService';
import { movementsList } from 'data/dashboard/crossfit';
import schema from './jsonSchema';
const jsonSchema = schema;
const mergedJsonSchema = (jsonSchema) => {
    const options = movementsList.map(movement => ({
        label: movement.name,
        value: movement.name
    }));
    const updatedJsonSchema = jsonSchema.map(f => {
        if (f.name === 'type') {
            return { ...f, options: options };
        }
        return f;
    });
    console.log('updatedJsonSchema', updatedJsonSchema);
    return updatedJsonSchema;
};
const PersonalRecordForm = ({setShowFormModal, refreshRecords}) => {
  const { identifier } = useParams();
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);


const handlePersonalRecordFormSubmit = formData => {
  PersonalRecordService.savePersonalRecord(formData)
    .then(response => {console.log(response); setShowFormModal(false); setModalShow(true); refreshRecords();})
    .catch(error => console.log(error));
};

  const buttonsConf = [
    {
      name: 'Save PR',
      type: 'submit',
      variant: 'info',
      icon: 'save',
      onClick: () => {
        console.log('Save PR');
      }
    }
  ];


  return (
    <>

      {modalShow && <FormModal message={'PersonalRecord  has been updated!'} modalShow={modalShow} setModalShow={setModalShow}/>}
      <Card>
        <Card.Body>
            {data || undefined === identifier ? (
            // Pass data to the form generator hook
            <FormGeneratorWithData data={data} buttonsConf={buttonsConf} onSubmit={handlePersonalRecordFormSubmit}/>
            ) : (
                <p>Loading...</p>
            )}
        </Card.Body>
      </Card>
    </>
  );
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit }) => {

    const [validated, setValidated] = useState(false);
    const buttonsGenerated = useButtonsGenerator(buttonsConf);
    // Use the useFormGenerator hook with the provided data
    const { formFields, handleSubmit, handleChange } = useFormGenerator(
      mergedJsonSchema(jsonSchema),
      onSubmit,
      data,
      setValidated
    );
  
    // Render your form using the formFields and event handlers
    return (
        <Form
        className="mb-2"
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
      >
        {formFields}
        <Card.Footer>{buttonsGenerated}</Card.Footer>
      </Form>
    );
  };
export default PersonalRecordForm;